// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function asArray <T = any> (what?: T[] | null | undefined): T[] {
  return Array.isArray(what) ? what : []
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNonEmptyArray <T = any> (what?: T[] | null, minLength = 0): what is T[] {
  return !!what && Array.isArray(what) && what.length > minLength
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function insertAtIndex <T = any> (array: T[], index: number, item: T) {
  const arrCopy = [...array]
  arrCopy.splice(index, 0, item)
  return arrCopy
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getEvenElementsFrom <T = any> (arr: T[]) {
  return arr.filter((_, index) => index % 2 === 0)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getOddElementsFrom <T = any> (arr: T[]) {
  return arr.filter((_, index) => index % 2 !== 0)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mergeArraysAlternately<T = any> (arr1: T[], arr2: T[]): T[] {
  return arr1.flatMap((item, index: number) => {
    if (arr2[index]) {
      return [item, arr2[index]]
    }
    return [item]
  })
}
